export class Note {
    constructor() {
        this.authorId = null;
        this.parentId = null;
        this.tenantId = null;
        this._id = null;
        this.text = "";
        this.deleted = false;
        this._dateAdded = new Date(); // this is loaded as the "real" (original) dataAdded value
        this.dateAddedManualOverride = null;
        this.wasEdited = false;
    }
    get createdBy() {
        return this.authorId;
    }
    // dateAdded is always used to display the "date added" value that the user sees.
    // Since we allow this to be overridden, we need to calculate that value.
    get dateAdded() {
        // If the dateAddedManualOverride is specified, it should be used (it wins).
        // If it doesn't exist, let's fallback to the actual dateAdded value.
        return this.dateAddedManualOverride || this._dateAdded;
    }
    clone() {
        return Note.clone(this);
    }
    static clone(source) {
        const theClone = new Note();
        if (!source) {
            return theClone;
        }
        theClone.authorId = source.authorId;
        theClone.text = source.text;
        theClone.deleted = source.deleted;
        theClone._dateAdded = source._dateAdded
            ? new Date(source._dateAdded)
            : new Date();
        theClone.dateAddedManualOverride = source.dateAddedManualOverride;
        theClone.wasEdited = source.wasEdited;
        theClone.tenantId = source.tenantId;
        theClone._id = source._id;
        return theClone;
    }
    static load(source) {
        const theClone = new Note();
        theClone.authorId = source.authorId;
        theClone.parentId = source.parentId;
        theClone.text = source.text;
        theClone.deleted = source.deleted;
        // Load the original dateAdded into _dateAdded so it's consistent with
        // IChangeTrackOverrideable expectations.
        // Note legacy notes previously used "updatedAt" for the creation date. We
        // first check if the note was created with the new dateAdded value, and use
        // that if available. Otherwise, fall back to the updatedAt value.
        theClone._dateAdded = new Date(source.dateAdded || source.updatedAt || 0);
        theClone.dateAddedManualOverride = source.dateAddedManualOverride
            ? new Date(source.dateAddedManualOverride)
            : null;
        theClone.wasEdited = source.wasEdited;
        theClone.tenantId = source.tenantId;
        theClone._id = source._id;
        return theClone;
    }
}
//# sourceMappingURL=note.js.map